import { compStyles } from '../styleBased/compStylesCompNode'
import { FontFacesCssFeature } from './fontFaces.types'
import { fontFacesCss } from './fontFacesCssCompNode'
import { fontFacesDomApplier } from './fontFacesDomApplier'
import { fontFamilies } from './fontFamiliesCompNode'

export const fontFacesCssFeature: FontFacesCssFeature = {
	experimentName: 'specs.thunderbolt.catharsis_fontFaces',
	renderableNodes: {},
	intermediateNodes: { fontFamilies, compStyles, fontFacesCss },
	dataMaps: ['theme_data', 'document_data', 'design_data'],
	domApplier: fontFacesDomApplier,
}
